export const DEVELOPER_DEVELOPERDETAIL_REQUEST =
  "DEVELOPER_DEVELOPERDETAIL_REQUEST";
export const DEVELOPER_DEVELOPERDETAIL_SUCCESS =
  "DEVELOPER_DEVELOPERDETAIL_SUCCESS";
export const DEVELOPER_DEVELOPERDETAIL_FAIL = "DEVELOPER_DEVELOPERDETAIL_FAIL";

export const DEVELOPER_DEVELOPERDETAILEDIT_REQUEST =
  "DEVELOPER_DEVELOPERDETAILEDIT_REQUEST";
export const DEVELOPER_DEVELOPERDETAILEDIT_SUCCESS =
  "DEVELOPER_DEVELOPERDETAILEDIT_SUCCESS";
export const DEVELOPER_DEVELOPERDETAILEDIT_FAIL =
  "DEVELOPER_DEVELOPERDETAILEDIT_FAIL";

export const DEVELOPER_APPLYLIST_REQUEST = "DEVELOPER_APPLYLIST_REQUEST";
export const DEVELOPER_APPLYLIST_SUCCESS = "DEVELOPER_APPLYLIST_SUCCESS";
export const DEVELOPER_APPLYLIST_FAIL = "DEVELOPER_APPLYLIST_FAIL";

export const DEVELOPER_APPLYDETAIL_REQUEST = "DEVELOPER_APPLYDETAIL_REQUEST";
export const DEVELOPER_APPLYDETAIL_SUCCESS = "DEVELOPER_APPLYDETAIL_SUCCESS";
export const DEVELOPER_APPLYDETAIL_FAIL = "DEVELOPER_APPLYDETAIL_FAIL";

export const DEVELOPER_APPLYUPDATE_REQUEST = "DEVELOPER_APPLYUPDATE_REQUEST";
export const DEVELOPER_APPLYUPDATE_SUCCESS = "DEVELOPER_APPLYUPDATE_SUCCESS";
export const DEVELOPER_APPLYUPDATE_FAIL = "DEVELOPER_APPLYUPDATE_FAIL";

export const DEVELOPER_APPLY_REQUEST = "DEVELOPER_APPLY_REQUEST";
export const DEVELOPER_APPLY_SUCCESS = "DEVELOPER_APPLY_SUCCESS";
export const DEVELOPER_APPLY_FAIL = "DEVELOPER_APPLY_FAIL";
export const DEVELOPER_APPLY_RESET = "DEVELOPER_APPLY_RESET";

export const DEVELOPER_BUILDAPPLY_REQUEST = "DEVELOPER_BUILDAPPLY_REQUEST";
export const DEVELOPER_BUILDAPPLY_SUCCESS = "DEVELOPER_BUILDAPPLY_SUCCESS";
export const DEVELOPER_BUILDAPPLY_FAIL = "DEVELOPER_BUILDAPPLY_FAIL";

export const DEVELOPER_BUILDAPPLYLIST_REQUEST =
  "DEVELOPER_BUILDAPPLYLIST_REQUEST";
export const DEVELOPER_BUILDAPPLYLIST_SUCCESS =
  "DEVELOPER_BUILDAPPLYLIST_SUCCESS";
export const DEVELOPER_BUILDAPPLYLIST_FAIL = "DEVELOPER_BUILDAPPLYLIST_FAIL";

export const DEVELOPER_LEARNLIST_REQUEST = "DEVELOPER_LEARNLIST_REQUEST";
export const DEVELOPER_LEARNLIST_SUCCESS = "DEVELOPER_LEARNLIST_SUCCESS";
export const DEVELOPER_LEARNLIST_FAIL = "DEVELOPER_LEARNLIST_FAIL";

export const DEVELOPER_LEARN_REQUEST = "DEVELOPER_LEARN_REQUEST";
export const DEVELOPER_LEARN_SUCCESS = "DEVELOPER_LEARN_SUCCESS";
export const DEVELOPER_LEARN_FAIL = "DEVELOPER_LEARN_FAIL";
export const DEVELOPER_LEARN_RESET = "DEVELOPER_LEARN_RESET";
